import api from '../../utils/services/api';
import dayjs from 'dayjs';

import {
  pixTransactionsActionLoading,
  pixTransactionsActionSuccess,
  pixTransactionsActionError,
  detailsPixTransactionActionLoading,
  detailsPixTransactionActionSuccess,
  detailsPixTransactionActionError,
} from '../ducks/pixTransactions';
import { showAlert } from '../ducks/sweetAlert';
import { pendingPixsActionError, pendingPixsActionLoading, pendingPixsActionSuccess } from '../ducks/pendingPix';

export const pixTransactionsFetchAction = (filter) => {
  return async (dispatch) => {
    dispatch(pixTransactionsActionLoading());

    try {
      const response = await api.post(`pix/relatorio_admin`, filter);
      dispatch(pixTransactionsActionSuccess(response));
    } catch (error) {
      dispatch(pixTransactionsActionError(error?.response?.data));
    }
  };
};

export const pixTransactionDebitDetailsFetchAction = (id) => {
  return async (dispatch) => {
    dispatch(detailsPixTransactionActionLoading());

    try {
      const response = await api.post(`pix/detalhes_debito`, id);
      dispatch(detailsPixTransactionActionSuccess(response));
    } catch (error) {
      dispatch(detailsPixTransactionActionError(error?.response?.data));
    }
  };
};

export const pixTransactionCreditDetailsFetchAction = (id) => {
  return async (dispatch) => {
    dispatch(detailsPixTransactionActionLoading());
    try {
      const response = await api.post(`pix/detalhes_credito`, id);
      dispatch(detailsPixTransactionActionSuccess(response));
    } catch (error) {
      dispatch(detailsPixTransactionActionError(error?.response?.data));
    }
  };
};

export const pixTransactionAproveFetchAction = (params, callback = () => null, filters) => {
  return async (dispatch) => {
    dispatch(pixTransactionsActionLoading());
    dispatch(showAlert({}));
    const closeModals = () => {
      callback?.();
      // dispatch(pixTransactionsFetchAction(filters));
    };
    try {
      const response = await api.post(`/admin/pix/aprovar/pagamento`, params);
      dispatch(
        showAlert({
          title: 'Sucesso',
          text: 'Pix aprovado com sucesso',
          icon: 'success',
          func: closeModals,
        }),
      );
    } catch (error) {
      dispatch(pixTransactionsActionError());
      const statusCode = error?.response?.status;
      const icon = statusCode === 409 ? 'warning' : 'error';

      dispatch(
        showAlert({
          title: error?.response?.data?.titulo ?? 'Ops...',
          text: error?.response?.data?.mensagem ?? 'Não foi possivel aprovar o pix',
          icon: icon,
          func: closeModals,
        }),
      );
    }
  };
};

export const pixTransactionNegadedFetchAction = (params, callback = () => null) => {
  return async (dispatch) => {
    dispatch(pixTransactionsActionLoading());
    dispatch(showAlert({}));
    const closeModals = () => {
      callback();
      dispatch(pixTransactionsFetchAction({ LIMIT: 10, PAGE: 1 }));
    };
    try {
      const response = await api.post(`/admin/pix/recusar/pagamento`, params);
      callback(response);
      dispatch(
        showAlert({
          title: 'Sucesso',
          text: 'Pix negado com sucesso',
          icon: 'success',
          func: closeModals,
        }),
      );
    } catch (error) {
      dispatch(pixTransactionsActionError());
      callback(error);
      dispatch(
        showAlert({
          title: 'Ops...',
          text: 'Não foi possivel negar o pix',
          icon: 'error',
          func: closeModals,
        }),
      );
    }
  };
};

export const pixTransactionAproveCelcoinFetchAction = (params, callback = () => null) => {
  return async (dispatch) => {
    dispatch(pixTransactionsActionLoading());
    dispatch(showAlert({}));
    const closeModals = () => {
      callback();
      dispatch(pixTransactionsFetchAction({ LIMIT: 10, PAGE: 1 }));
    };
    try {
      const response = await api.post(`/admin/pix/aprovar/pagamento/status`, params);
      callback(response);
      dispatch(
        showAlert({
          title: 'Sucesso',
          text: 'Pix aprovado com sucesso',
          icon: 'success',
          func: closeModals,
        }),
      );
    } catch (error) {
      dispatch(pixTransactionsActionError());
      callback(error);
      dispatch(
        showAlert({
          title: 'Ops...',
          text: 'Não foi possivel aprovar o pix',
          icon: 'error',
          func: closeModals,
        }),
      );
    }
  };
};

export const pixTransactionPendingPixFetchAction = () => {
  return async (dispatch) => {
    dispatch(pendingPixsActionLoading());
    try {
      const response = await api.get(`/pix/aguardando_aprovacao`);

      dispatch(pendingPixsActionSuccess(response.data));
    } catch (error) {
      dispatch(pendingPixsActionError(error?.response?.data));
    }
  };
};

export const pixRefundAproveFetchAction = (params, callback = () => null) => {
  return async (dispatch) => {
    dispatch(pixTransactionsActionLoading());
    dispatch(showAlert({}));
    const closeModals = () => {
      callback();
      dispatch(pixTransactionsFetchAction({ LIMIT: 10, PAGE: 1 }));
    };
    try {
      const response = await api.post(`/admin/pix/aprovar/devolucao`, params);
      callback(response);
      dispatch(
        showAlert({
          title: 'Sucesso',
          text: 'Pix aprovado com sucesso',
          icon: 'success',
          func: closeModals,
        }),
      );
    } catch (error) {
      dispatch(pixTransactionsActionError());
      callback(error);

      dispatch(
        showAlert({
          title: 'Ops...',
          text: error.response?.data?.mensagem ?? 'Não foi possivel aprovar o pix',
          icon: 'error',
          func: closeModals,
        }),
      );
    }
  };
};

export const pixRefundNegadedFetchAction = (params, callback = () => null) => {
  return async (dispatch) => {
    dispatch(pixTransactionsActionLoading());
    dispatch(showAlert({}));
    const closeModals = () => {
      callback();
      dispatch(pixTransactionsFetchAction({ LIMIT: 10, PAGE: 1 }));
    };
    try {
      const response = await api.post(`/admin/pix/recusar/devolucao`, params);
      callback(response);
      dispatch(
        showAlert({
          title: 'Sucesso',
          text: 'Reembolso negado com sucesso',
          icon: 'success',
          func: closeModals,
        }),
      );
    } catch (error) {
      dispatch(pixTransactionsActionError());
      callback(error);
      dispatch(
        showAlert({
          title: 'Ops...',
          text: 'Não foi possivel negar o reembolso',
          icon: 'error',
          func: closeModals,
        }),
      );
    }
  };
};

export const getReceiptForView = async (id) => {
    const {data}  = await api.get(`/admin/transacao/historico_transacoes_PJ/detalhe/`, {
      params: {
        ID: id,
        ACAO: 'download',
      },
      responseType: 'blob',
    });

    // handleDownloadFile(data, `Comprovante_Pix_${id}`)

    return data;
};

  export const handleDownloadFile = (blob, fileName) => {
  const link = document.createElement('a')
  link.href = URL.createObjectURL(blob)
  link.target = '_blank'
  link.setAttribute('download', `${fileName}`)
  document.body.appendChild(link)
  link.click()
  document.body.removeChild(link)
  URL.revokeObjectURL(blob)
}
